import { LucideIcon } from "lucide-react";
import React from "react";
import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
  action: {
    label: string;
    onClick?: () => void;
    href?: string;
  };
}

export const EmptyState: React.FC<EmptyStateProps> = ({ icon: Icon, title, description, action }) => {
  return (
    <div className="flex flex-col items-center justify-center h-[50vh] text-center p-6">
      <Icon className="w-16 h-16 mb-4 text-zinc-400" />
      <h2 className="text-2xl font-bold mb-2">{title}</h2>
      <p className="text-zinc-400 mb-6 max-w-md">{description}</p>
      {action.href ? (
        <Link
          to={action.href}
          className="px-6 py-3 bg-yellow-500 text-white rounded-full hover:bg-yellow-600 transition"
        >
          {action.label}
        </Link>
      ) : (
        <button
          onClick={action.onClick}
          className="px-6 py-3 bg-yellow-500 text-white rounded-full hover:bg-yellow-600 transition"
        >
          {action.label}
        </button>
      )}
    </div>
  );
};
